<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M13.635 7.5 12.36 3.99A1.506 1.506 0 0 0 10.95 3H9v1.5h1.95l1.095 3H8.438l-.27-.75H9v-1.5H5.25v1.5h1.313l1.365 3.75h-.503a3.698 3.698 0 0 0-3.487-2.992C1.837 7.402 0 9.15 0 11.25S1.65 15 3.75 15c1.845 0 3.338-1.268 3.675-3h3.15a3.698 3.698 0 0 0 3.488 2.992c2.1.098 3.937-1.642 3.937-3.75 0-2.1-1.65-3.75-3.75-3.75h-.615V7.5ZM5.865 12c-.3.877-1.118 1.5-2.115 1.5-1.26 0-2.25-.99-2.25-2.25S2.49 9 3.75 9c.997 0 1.815.623 2.115 1.5H3.75V12h2.115Zm4.71-1.5h-1.05L8.977 9h2.273a3.55 3.55 0 0 0-.675 1.5Zm3.675 3c-1.26 0-2.25-.99-2.25-2.25 0-.697.307-1.297.787-1.71l.72 1.98 1.41-.51-.727-2.002c.023 0 .045-.008.068-.008 1.26 0 2.25.99 2.25 2.25s-.998 2.25-2.258 2.25Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
